import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full max-w-screen-xl mx-auto px-6 py-10" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "text-2xl leading-tight font-light tracking-wide text-brand-main font-serif" }
const _hoisted_5 = {
  class: "text-2xl w-6 mr-10 text-brand-main",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-10"
}
const _hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-10"
}
const _hoisted_8 = ["onClick", "aria-expanded", "aria-controls"]
const _hoisted_9 = { class: "text-2xl leading-tight font-light tracking-wide text-brand-main font-serif" }
const _hoisted_10 = {
  class: "text-2xl w-6 mr-10 text-brand-main",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-10"
}
const _hoisted_12 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-10"
}
const _hoisted_13 = { class: "pb-6 mx-10" }
const _hoisted_14 = { class: "grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4 text-black text-sm" }
const _hoisted_15 = { class: "flex items-baseline gap-2 whitespace-nowrap" }
const _hoisted_16 = { class: "text-brand-main tracking-wide font-bold" }
const _hoisted_17 = { class: "flex items-baseline gap-2 whitespace-nowrap" }
const _hoisted_18 = { class: "text-brand-main tracking-wide font-bold" }
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = ["onClick", "title"]
const _hoisted_21 = { class: "select-all" }
const _hoisted_22 = ["onClick", "aria-label"]
const _hoisted_23 = {
  key: 0,
  class: "text-brand-main"
}
const _hoisted_24 = { class: "flex items-baseline gap-2 whitespace-nowrap" }
const _hoisted_25 = { class: "text-brand-main tracking-wide font-bold" }
const _hoisted_26 = {
  key: 0,
  href: "/ueber_rubin/nachhaltigkeit#certificate",
  target: "_blank",
  class: "text-black underline"
}
const _hoisted_27 = {
  key: 1,
  href: "/ueber_steinberg/nachhaltigkeit#certificate",
  target: "_blank",
  class: "text-black underline"
}
const _hoisted_28 = ["id"]
const _hoisted_29 = { class: "grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4 text-black text-sm" }
const _hoisted_30 = {
  role: "list",
  class: "space-y-2"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "text-brand-main pr-2 tracking-wide font-bold" }
const _hoisted_34 = { class: "mb-2" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "text-brand-main pr-2 tracking-wide font-bold" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "ml-2" }
const _hoisted_39 = {
  key: 0,
  class: "flex items-baseline gap-2 whitespace-nowrap mb-2"
}
const _hoisted_40 = { class: "text-brand-main pr-2 tracking-wide" }
const _hoisted_41 = {
  href: "/diamanten/5cs#confidence",
  target: "_blank",
  class: "text-black underline"
}
const _hoisted_42 = { class: "text-brand-main tracking-wide font-bold" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }

import {computed, ref} from "vue";
import DescriptionPartsSub from "@/components/description/descriptionPartsSub.vue";
import {useI18n} from "vue-i18n";

interface DescriptionItem {
  itemPrice: {
    total: number;
    parts: {
      item: number,
      stones: number
    }
  },
  itemNumber: string;
  description: string;
  partsList: any[]
}

const pageStr = "components.description.descriptionParts"

// UI state (matches screenshot: description open, details closed)

export default /*@__PURE__*/_defineComponent({
  __name: 'descriptionParts',
  props: {
    items: {}
  },
  setup(__props: any) {

const {t} = useI18n();

const props = __props;

const isDescriptionOpen = ref(true);
const isDetailsOpen = ref<boolean[]>([]);

const toggleDetails = (idx: number) => {
  isDetailsOpen.value[idx] = !isDetailsOpen.value[idx];
};

// Copy to clipboard state
const copiedIdx = ref<number | null>(null);

const copyItemNumber = async (itemNumber: string, idx: number) => {
  const text = String(itemNumber ?? '');
  if (!text) return;
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      // Fallback for older browsers
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    copiedIdx.value = idx;
    window.setTimeout(() => {
      if (copiedIdx.value === idx) copiedIdx.value = null;
    }, 1500);
  } catch {
    // Ignore errors silently, do not break UI
  }
};

// Title/description is only shown once, taken from the first item
const description = computed(() => props.items?.[0]?.description ?? '');

// Build the ordered root-level rows and the parts-with-subs columns for a single item
const buildItemView = (item: DescriptionItem) => {
  const partsList = item.partsList || [];

  const partsWithSubs = partsList.filter((p: any) => Array.isArray(p?.sub) && p.sub.length > 0);
  const partsWithoutSubs = partsList.filter((p: any) => !Array.isArray(p?.sub) || p.sub.length === 0);

  // Order by `parameter` key; merge width+height on one line
  const order: string[] = [
    'item_type',
    'set_id',
    'metal',
    'color',
    'width_height', // special synthetic key for merged display
    'size',
    'length',
  ];

  const rows: { parameter: string; title: string; value: string }[] = [];

  const itemsByParam = new Map<string, any>();
  for (const p of partsWithoutSubs) {
    if (p && typeof p === 'object' && p.parameter) {
      itemsByParam.set(p.parameter, p);
    }
  }

  // Helper to safely get title/value
  const makeRow = (p: any, fallbackParam: string) => ({
    parameter: p?.parameter ?? fallbackParam,
    title: p?.title ?? '',
    value: p?.value ?? '',
  });

  // Precompute width/height
  const width = itemsByParam.get('width');
  const height = itemsByParam.get('height');

  // Build rows in specified order
  for (const key of order) {
    if (key === 'width_height') {
      if ((width?.value ?? '') !== '' || (height?.value ?? '') !== '') {
        const wTitle = width?.title || t(`${pageStr}.width`);
        const hTitle = height?.title || t(`${pageStr}.height`);
        const wVal = width?.value ?? '';
        const hVal = height?.value ?? '';
        const label = `${wTitle} × ${hTitle}`;
        const value = [wVal, hVal].filter(Boolean).join(' × ');
        rows.push({parameter: 'width_height', title: label, value});
      }
      continue;
    }
    const found = itemsByParam.get(key);
    if (found && (found.value ?? '') !== '') {
      rows.push(makeRow(found, key));
      itemsByParam.delete(key);
    }
  }

  // Append all remaining root-level items not in the order list (excluding width/height already handled)
  for (const [param, itm] of itemsByParam.entries()) {
    if (param === 'width' || param === 'height') continue; // already represented
    if ((itm?.value ?? '') === '') continue;
    rows.push(makeRow(itm, param));
  }

  return {
    itemPrice: item.itemPrice,
    itemNumber: item.itemNumber,
    partsWithSubs,
    orderedRootRows: rows,
  };
};

// Per-item processed view: price, item number, ordered rows and parts-with-subs columns
const processedItems = computed(() => (props.items || []).map(buildItemView));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center justify-between py-7 focus:outline-none select-none",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isDescriptionOpen.value = !isDescriptionOpen.value)),
        "aria-expanded": isDescriptionOpen.value ? 'true' : 'false',
        "aria-controls": "description-panel"
      }, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t(`${pageStr}.product_description`)), 1),
        _createElementVNode("span", _hoisted_5, [
          (!isDescriptionOpen.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M12 4.5v15m7.5-7.5h-15"
                }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M5 12h14"
                }, null, -1)
              ]))]))
        ])
      ], 8, _hoisted_3),
      _withDirectives(_createElementVNode("div", {
        id: "description-panel",
        class: "pl-10 pb-7 text-sm leading-8 text-black font-light tracking-widerst"
      }, _toDisplayString(description.value), 513), [
        [_vShow, isDescriptionOpen.value]
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedItems.value, (item, itemIdx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `details-${itemIdx}-${item.itemNumber}`,
        class: "border-t border-brand-main"
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "flex w-full items-center justify-between py-7 focus:outline-none select-none",
          onClick: ($event: any) => (toggleDetails(itemIdx)),
          "aria-expanded": isDetailsOpen.value[itemIdx] ? 'true' : 'false',
          "aria-controls": `details-panel-${itemIdx}`
        }, [
          _createElementVNode("h3", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.$t(`${pageStr}.product_details`)) + " ", 1),
            (processedItems.value.length > 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(itemIdx + 1), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_10, [
            (!isDetailsOpen.value[itemIdx])
              ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 4.5v15m7.5-7.5h-15"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M5 12h14"
                  }, null, -1)
                ]))]))
          ])
        ], 8, _hoisted_8),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(`${pageStr}.total_price`)) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$n(item.itemPrice.total, 'currency')), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(`${pageStr}.item_number`)) + ":", 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (copyItemNumber(item.itemNumber, itemIdx)),
                  class: "text-black hover:opacity-80 focus:outline-none underline decoration-dotted underline-offset-4",
                  title: _ctx.$t(`${pageStr}.copy_item_number`)
                }, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(item.itemNumber), 1)
                ], 8, _hoisted_20),
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (copyItemNumber(item.itemNumber, itemIdx)),
                  "aria-label": _ctx.$t(`${pageStr}.copy_item_number`),
                  class: "p-1 rounded hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-main"
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "w-5 h-5"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M8 7.5V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 20 6v7.5A2.25 2.25 0 0 1 17.75 15H16.5m-9 3.75h7.5A2.25 2.25 0 0 0 17.25 16.5v-7.5A2.25 2.25 0 0 0 15 6.75H7.5A2.25 2.25 0 0 0 5.25 9v7.5A2.25 2.25 0 0 0 7.5 18.75Z"
                    })
                  ], -1)
                ]))], 8, _hoisted_22),
                (copiedIdx.value === itemIdx)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t(`${pageStr}.copied`)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t(`${pageStr}.certificate`)) + ":", 1),
              (item.itemNumber.includes('R-'))
                ? (_openBlock(), _createElementBlock("a", _hoisted_26, _toDisplayString(_ctx.$t(`${pageStr}.authenticity_manufacturer_certificate`)), 1))
                : (_openBlock(), _createElementBlock("a", _hoisted_27, _toDisplayString(_ctx.$t(`${pageStr}.authenticity_manufacturer_certificate`)), 1))
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", {
          id: `details-panel-${itemIdx}`,
          class: "pb-6 mx-10 border-t border-brand-main pt-7"
        }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", null, [
              _createElementVNode("ul", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.orderedRootRows, (row, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `root-${itemIdx}-${idx}-${row.parameter}`
                  }, [
                    (row.title && row.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-brand-main pr-2 tracking-wide", {'font-bold': row.parameter === 'item_type'}])
                          }, _toDisplayString(row.title) + ":", 3),
                          _createElementVNode("span", null, _toDisplayString(row.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                ((item.itemPrice?.parts?.item || 0) > 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t(`${pageStr}.item_price`)) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$n(item.itemPrice.parts.item, 'currency')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.partsWithSubs, (col, cIdx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `col-${itemIdx}-${cIdx}-${col.parameter || cIdx}`
              }, [
                _createElementVNode("div", _hoisted_34, [
                  (col.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(col.title) + ":", 1),
                        (col.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(col.value), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(DescriptionPartsSub, {
                    "sub-list": col.sub
                  }, null, 8, ["sub-list"]),
                  (col.parameter != 'discs')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t(`${pageStr}.origin`)) + ":", 1),
                          _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.$t(`${pageStr}.conflict_free_diamond`)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((item.itemPrice?.parts[col.parameter] || item.itemPrice?.parts[''] || 0) > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "flex items-baseline gap-2 whitespace-nowrap",
                        style: _normalizeStyle({
                gridColumn: (1 + item.partsWithSubs.length) > 1
                  ? '2 / -1'
                  : '1 / -1'
              })
                      }, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t(`${pageStr}.price_of`, {title: col.title})), 1),
                        (item.itemPrice.parts[col.parameter])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$n(item.itemPrice.parts[col.parameter], 'currency')), 1))
                          : (item.itemPrice.parts[''])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$n(item.itemPrice.parts[''], 'currency')), 1))
                            : _createCommentVNode("", true)
                      ], 4))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ], 8, _hoisted_28), [
          [_vShow, isDetailsOpen.value[itemIdx]]
        ])
      ]))
    }), 128)),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "border-t border-brand-main" }, null, -1))
  ]))
}
}

})